'use strict';

const SELECTORS = {
    blog: '.js-blog-list-wrp',
    list: '.js-blog-list',
    filterBtn: '.js-filter-btn',
    filterSelect: 'select.js-filter-select',
    noresults: '.js-blog-noresults',
    counter: '.js-articles-count',
    article: '.js-blog-card',
};

const CLASSES = {
    active: 'cc-active',
}

/**
 * Blog class to handle blog list functionality
 * @class Blog
 */
class Blog {
    constructor(element) {
        this.element = element;
        this.list = element.find(SELECTORS.list);
        this.filterBtn = element.find(SELECTORS.filterBtn);
        this.filterSelect = element.find(SELECTORS.filterSelect);
        this.counter = element.find(SELECTORS.counter);
        this.initEvents();
    }

    initEvents() {
        this.onFilterButtonClick();
        this.onFilterSelectChange();
    }

    /**
     * Handles the click event on filter buttons
     * @memberof Blog
     * @method onFilterButtonClick
     * @description This method adds a click event listener to filter buttons. When a button is clicked, it updates the active class, retrieves the value from the button, updates the URL with the selected filter, and refreshes the articles list.
     * @returns {void}
     */
    onFilterButtonClick() {
        $(this.filterBtn).on('click', (evt) => {
            evt.preventDefault();
            $(SELECTORS.filterBtn).removeClass(CLASSES.active);
            $(evt.currentTarget).addClass(CLASSES.active);
            const value = $(evt.currentTarget).data('value') || '';
            this.updateURLwithFilter('tag', value);
            this.updateArticlesList();
        });
    }

    /**
     * Handles the change event on filter select dropdown
     * @memberof Blog
     * @method onFilterSelectChange
     * @description This method adds a change event listener to the filter select dropdown. When the selected option changes, it retrieves the value, updates the URL with the selected filter, and refreshes the articles list.
     * @returns {void}
     */
    onFilterSelectChange() {
        $(this.filterSelect).on('change', (evt) => {
            const value = $(evt.currentTarget).val();
            this.updateURLwithFilter('filter', value);
            this.updateArticlesList();
        });
    }

    /**
     * Updates the URL with the selected filter
     * @memberof Blog
     * @method updateURLwithFilter
     * @description This method updates the current URL with the selected filter type and value. If the value is 'all', it removes the filter from the URL; otherwise, it sets the filter in the URL.
     * @returns {void}
     * @param {String} type  
     * @param {String} value 
     */
    updateURLwithFilter(type, value) {
      const currentUrl = new URL(window.location.href);
      if (value === 'all') {
            currentUrl.searchParams.delete(type);
      } else {
            currentUrl.searchParams.set(type, value);
      }
      window.history.pushState({}, '', currentUrl);
    }


    /**
     * Updates the articles list based on the selected filters
     * @memberof Blog
     * @method updateArticlesList
     * @description This method fetches the articles list from the server based on the selected filters and updates the DOM with the new list. If no articles are found, it displays a message indicating no results.
     * @returns {void}
     */
    updateArticlesList() {
        $.spinner().start();
        let url = this.element.data('action');
        const tag = $(SELECTORS.filterBtn + '.' + CLASSES.active).data('value') || '';
        const filter = $(SELECTORS.filterSelect).val() || '';
        const params = new URLSearchParams();
        if (tag && tag !== 'all') {
            params.set('tag', tag);
        }
        if (filter && filter !== 'all') {
            params.set('filter', filter);
        }
        if (params.toString()) {
            url += '?' + params.toString();
        }

        $.ajax({
            url: url,
            method: 'GET',
            success: async (data) => {
                if (data.success) {
                    await $(this.list).html(data.renderedTemplate);
                }

                const articlesCount = this.list.find(SELECTORS.article).length;

                this.counter.text(articlesCount);

                if (articlesCount === 0) {
                    const emptyMessage = this.element.data('empty-msg');
                    $(this.list).html(`<p class="cc-blog-list__no-results">${emptyMessage}</p>`);
                }

                $.spinner().stop();
            },
            error: (err) => {
                $.spinner().stop();
            }
        });
    }
}

$(function() {
    $(SELECTORS.blog).each((index, element) => {
        new Blog($(element));
    });
});